<template>
  <Dialog :open="showModal" @update:open="onDialogUpdate">
    <DialogTrigger as-child>
      <button type="button" class="btn btn-warning">
        {{ $t('Confirm my participation') }}
      </button>
    </DialogTrigger>
    <DialogScrollContent>
      <form :action="actionUrl" method="post">
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="_method" value="PUT">
        <DialogHeader>
          <DialogTitle>{{ $t('Confirm my participation') }}</DialogTitle>
        </DialogHeader>

        <p class="tw:text-sm tw:mt-3 tw:mb-2">
          {{ $t('Select the exhibitor you want to validate for this event') }}
        </p>

        <div class="tw:flex tw:flex-col tw:gap-2">
          <label v-for="exponent in exponents" :key="exponent.id"
                 class="tw:flex tw:items-center tw:gap-2 tw:cursor-pointer">
            <input type="radio" name="selected_exponent" :value="exponent.id" v-model="selectedExponentId" required>
            <span>{{ exponent.name }}</span>
          </label>
        </div>

        <DialogFooter class="tw:mt-4">
          <Button variant="secondary" type="button" @click="showModal = false">
            {{ $t('Cancel') }}
          </Button>
          <Button variant="default" type="submit" :disabled="!selectedExponentId">
            {{ $t('Confirm') }}
          </Button>
        </DialogFooter>
      </form>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { Dialog, DialogScrollContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/shadcn/components/ui/button/index.js";

const props = defineProps({
  exponents: { type: Array, required: true },
  routeTemplate: { type: String, required: true },
});

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
const showModal = ref(false);
const selectedExponentId = ref(null);

const actionUrl = computed(() =>
  selectedExponentId.value
    ? props.routeTemplate.replace('__EXPONENT__', selectedExponentId.value)
    : '#'
);

const onDialogUpdate = (isOpen) => {
  showModal.value = isOpen;
  if (!isOpen) {
    selectedExponentId.value = null;
  }
};
</script>
